import React from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';

import checkPermission from './permissions';

const propTypes = {
  onDoubleClick: PropTypes.func,
  value: PropTypes.string,
  dependentValues: PropTypes.shape({}),
};

const defaultProps = {
  onDoubleClick: undefined,
  value: '',
  dependentValues: {},
};

const ProdNumFormatter = props => (
  <span
    onDoubleClick={() => {
      if (isFunction(props.onDoubleClick)) {
        if (checkPermission('change_product')) {
          props.onDoubleClick(props.dependentValues);
        } else {
          alert(I18n.t('msg_no_permission'));
        }
      }
    }}
  >
    {/* Javascript slice returns an empty string when outOfBound */}
    <span style={{ color: '#585858' }}>{ props.value.slice(0, 2) }</span>
    <span style={{ color: '#0B609F' }}>{ props.value.slice(2, 4) }</span>
    <span style={{ color: 'black' }}>{ props.value.slice(4, 7) }</span>
    <span style={{ color: 'black' }}>{ props.value.slice(7) }</span>
  </span>
);

ProdNumFormatter.propTypes = propTypes;
ProdNumFormatter.defaultProps = defaultProps;

export default ProdNumFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/ProdNumFormatter.jsx